module.exports = __webpack_public_path__ + "static/img/b3.026f1c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b3.png
// module id = 6E2S
// module chunks = 1